class PdpUpsellItemSize extends HTMLElement {
  constructor() {
    super();
  }
  // Method called when the element is added to the document.
  connectedCallback() {
    this.section = this;
    this.select = this.section.querySelector("#pdp-upsell-item-size-selector");
    this.hasMappedSizes = this.select.dataset.hasMappedSizes;
    this.select.addEventListener("change", this.selectEventHandler.bind(this));
  }

  // Method called when the element is removed from the document.
  disconnectedCallback() {
    this.select.removeEventListener("change", this.selectEventHandler);
  }

  /**
   * Event handler for the select element's change event.
   * Dispatches a custom event with details about the selected size.
   *
   * @param {Event} event - The change event triggered by the select element.
   */
  selectEventHandler(event) {
    let detail;
    const { value } = event.target;

    if (this.hasMappedSizes === "true") {
      const { sizeHandle } = event.target.querySelector(
        `option[value="${value}"]`
      ).dataset;

      detail = {
        size: sizeHandle,
        mappedSize: value,
      };
    } else {
      detail = {
        size: value,
        mappedSize: false,
      };
    }

    this.dispatchEvent(
      new CustomEvent("pdp-upsell-item-size-change", {
        bubbles: true,
        detail,
      })
    );
  }

  /**
   * Gets the current size selected in the select element.
   *
   * @returns {Object} An object containing the current size, mapped size, and a flag indicating if the current size is null.
   */
  getCurrentSize() {
    let detail;
    const value =
      this.select.value === "null"
        ? this.select.querySelector(`option:nth-child(2)`).value
        : this.select.value;
    const isCurrentSizeNull = this.select.value === "null";

    if (this.hasMappedSizes === "true") {
      const { sizeHandle } = this.select.querySelector(
        `option[value="${value}"]`
      ).dataset;
      detail = {
        size: sizeHandle,
        mappedSize: value,
        isCurrentSizeNull,
      };
    } else {
      detail = {
        size: value,
        mappedSize: false,
        isCurrentSizeNull,
      };
    }

    return detail;
  }

  /**
   * Resets the select element to its default value (the first option).
   */
  resetValue() {
    this.select.value = this.select.querySelector(`option:first-child`).value;
  }
}
customElements.define("pdp-upsell-item-size", PdpUpsellItemSize);
